<template>
    <div id="organizacion">
        <div class="container-fluid">
            <div class="row main-content">
                <div class="col-md-12" data-aos="fade-down">
                    <div class="small-title">
                        <h4 v-html="state.title"></h4>
                        <hr>
                    </div>
                    <div style="max-width: 938px; margin: auto;">
                        <h1>{{state.subTitle}}</h1>
                        <p style="font-size:15pt;" v-html="state.bannerTextBottom"></p>
                        <div class="img-div">
                            <img src="./../../assets/icons/logo_santoyo_rojo.png">
                        </div>
                        <div style="border:3px solid red; margin-top:-80px; margin-bottom:80px;">
                            <div class="img-valores">
                                <div class="img-div">
                                    <img src="./../../assets/icons/icon_direccion.png">
                                    <hr>
                                    <br>
                                    <p>{{state.imgTxt1}}</p>
                                    <hr class="white-hr">
                                </div>
                                <div class="img-div">
                                    <img src="./../../assets/icons/icon_despacho.png">
                                    <hr>
                                    <br>
                                    <p>{{state.imgTxt2}}</p>
                                    <hr class="white-hr">
                                </div>
                                <div class="img-div">
                                    <img src="./../../assets/icons/icon_logistica.png">
                                    <hr>
                                    <br>
                                    <p v-html="state.imgTxt3"></p>
                                </div>
                                <div class="img-div">
                                    <img src="./../../assets/icons/icon_contabilidad.png">
                                    <br>
                                    <p>{{state.imgTxt4}}
                                        <div class="vertical-div" style=" position:absolute; margin-left:90px;   border-left:2px solid #808080;height:30px;"></div>
                                    </p>
                                </div>
    
                            </div>
                            <div class="img-valores">
                                <div class="img-div">
                                    <img src="./../../assets/icons/icon_operador.png">
                                    <hr>
                                    <br>
                                    <p>{{state.imgTxt5}}
                                        <div class="vertical-div" style=" position:absolute; margin-left:90px; border-left:2px solid #808080;height:30px;"></div>
                                    </p>
                                    <hr class="white-hr">
                                </div>
                                <div class="img-div">
                                    <img src="./../../assets/icons/icon_mecanica.png">
                                    <hr>
                                    <br>
                                    <p>{{state.imgTxt6}}</p>
                                    <hr class="white-hr">
                                </div>
                                <div class="img-div">
                                    <img src="./../../assets/icons/icon_ctpat.png">
                                    <hr>
                                    <br>
                                    <p>{{state.imgTxt7}}</p>
                                    <hr class="white-hr">
                                </div>
                                <div class="img-div">
                                    <img src="./../../assets/icons/icon_recursos.png">
                                    <br>
                                    <p>{{state.imgTxt8}}</p>
                                    <hr class="white-hr">
                                </div>
    
                            </div>
                            <div class="img-valores left-align">
                                <div class="img-div">
                                    <img src="./../../assets/icons/icon_compras.png">
                                    <hr>
                                    <br>
                                    <p>{{state.imgTxt9}}</p>
                                    <hr class="white-hr">
                                </div>
                                <div class="img-div">
                                    <img src="./../../assets/icons/icon_administracion.png">
                                    <hr>
                                    <br>
                                    <p>{{state.imgTxt10}}</p>
                                    <hr class="white-hr">
                                </div>
                                <div class="img-div">
                                    <img src="./../../assets/icons/icon_almacen.png">
                                    <br>
                                    <p>{{state.imgTxt11}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    methods: {
    },
    components: {
    },
    computed: {
        state() {
            return this.$store.state.activeList.aboutUsOrg
        }
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

#valores {
    background-color: white;
    color: $azul;
}

.main-content {
    margin-top: 100px;
}

h1 {
    color: $azul;
}

h2 {
    color: white;
    display: inline-block;
}

h4 {
    color: $gris;
    display: inline-block;
}

hr {
    display: inline-block;
    vertical-align: middle;
    height: 2px;
    border: 0;
    width: 30%;
    border-top: 2px solid $rojo;
    margin: 1em 1em;
    padding: 0;
}

.left-align {
    text-align: left!important;
}

.img-valores hr {
    display: inline-block;
    vertical-align: middle;
    height: 2px;
    border: 0;
    width: 30px;
    border-top: 2px solid $gris;
    margin: 1em 1em;
    padding: 0;
}

.white-hr {
    border-top: 2px solid white!important;
}

.text-container {
    text-align: left;
    margin-top: 5%;
}

.img-div {
    display: inline-block;
    color: $gris;
}

.small-title {
    text-align: left;
    vertical-align: middle;
    padding: 40px 80px;
}

.img-contnt {
    text-align: right;
}

.img-valores p {
    color: $gris;
    text-align: center;
    display: inline-block;
}

.img-valores img {
    width: 100px;
    margin: 40px;
}

.img-valores {
    text-align: center;
}

.container-fluid,
.col-md-9,
.col-md-6,
.col-md-3,
.col-md-10,
.col-md-12 {
    padding-left: 0px !important;
    padding-right: 0px !important;
}

.row,
.col-md-9,
.col-md-3,
.col-md-10,
.col-md-12 {
    margin-left: 0px!important;
    margin-right: 0px!important;
}


@media screen and (max-width:1040px) {
    .small-title {
        text-align: left;
        vertical-align: middle;
        padding: 40px 10px;
    }
}

@media screen and (max-width:912px) {
    hr {
        display: none!important;
    }
    .white-hr {
        display: none;
    }
    .vertical-div {
        display: none;
    }

    .left-align {
        text-align: center!important;
    }
}
</style>



// WEBPACK FOOTER //
// OrganizacionPage.vue?36c19938